import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { api, shopLogoUrl } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { usePrintReady } from "@/lib/print";

const css = `@page { size: A4; margin: 10mm; } @media print { .no-print { display: none !important; } body { background: #fff !important; } }`;

export default function MechanicQrPrint() {
  const { user } = useAuth();
  const [ready, setReady] = useState(false);
  const [emps, setEmps] = useState([]);
  useEffect(() => {
    api.get("/employees").then(({ data }) => {
      setEmps((data || []).filter((e) => e.role === "mecanico" && e.active !== false));
      setReady(true);
    }).catch(() => setReady(true));
  }, []);
  usePrintReady(ready ? "ready" : "loading");
  const shop = user?.shop || {};
  const slug = shop.slug;
  const base = window.location.origin;
  const url = slug ? `${base}/m/${slug}` : null;
  if (!slug) return <div className="p-6 text-sm">A oficina não tem endereço público configurado.</div>;
  return (
    <div className="min-h-screen bg-white text-black">
      <style>{css}</style>
      <div className="no-print p-4 flex gap-2 justify-end">
        <button type="button" onClick={() => window.print()} data-testid="mechqr-print" className="px-4 py-2 bg-black text-white rounded text-sm font-bold">Imprimir</button>
      </div>
      <div className="max-w-xl mx-auto p-6 text-center" data-testid="mechqr-poster">
        {shop.id && shop.logo_path && (
          <img src={shopLogoUrl(shop.id)} alt={shop.name} className="h-16 mx-auto mb-3" />
        )}
        <div className="text-xs uppercase tracking-widest text-zinc-500">Equipe mecânica</div>
        <h1 className="text-3xl font-black uppercase mt-1" style={{ fontFamily: "Impact, Oswald, sans-serif" }}>{shop.name || "Oficina"}</h1>
        <p className="mt-3 text-base">Mecânico: escaneie o QR, toque no seu nome e digite seu PIN de 4 dígitos.</p>
        <div className="my-6 flex justify-center">
          <QRCodeSVG value={url} size={340} />
        </div>
        <div className="text-xs break-all text-zinc-700">{url}</div>
        {emps.length > 0 && (
          <div className="mt-6 text-left">
            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2">Mecânicos cadastrados</div>
            <ul className="grid grid-cols-2 gap-y-1 text-sm">
              {emps.map((e) => (<li key={e.id}>• {e.name}</li>))}
            </ul>
          </div>
        )}
        <p className="mt-6 text-xs text-zinc-600">O dono controla os PINs em Funcionários (RH).</p>
      </div>
    </div>
  );
}
